export enum PaymentTypeEnum {
  BANK_TRANSFER = 'bank_transfer',
  CASH = 'cash',
  PAYMENT_CARD = 'payment_card',
  FREE_OF_CHARGE = 'free_of_charge',
}
